import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import { Modal } from 'react-bootstrap'
import { checkUploadStatus, alert, toaster } from '../../../../../utils/helper'
import { useMutation } from '@apollo/client'
import closeIcon from '../../../../../_metronic/images/closeSymbol.svg'

import { useFormik } from 'formik'
import { UPLOAD_AGENTS, CREATE_AGENTS } from '../../../../../utils/GraphQLAPI'

import AddAgent from '../steps/AddAgent'

import * as Yup from 'yup'
import uuid from 'react-uuid'
type Props = {
  show: boolean
  handleClose: () => void
  refetchList: () => void
  salesChannelId?: string
  agentLeaderList: any
  handleCreateAgentSubmit: any
}

const modalsRoot = document.getElementById('root-modals') || document.body

const CreateAgentModel = ({
  show,
  handleClose,
  refetchList,
  salesChannelId,
  agentLeaderList,
  handleCreateAgentSubmit,
}: Props) => {
  const initialFormValue = {
    agent: [], //agentList
    agentLeaders: agentLeaderList,
  }
  const [generatedTrackId, setGenerateTrackId] = useState<any>('')
  const [isSubmit, setIsSubmit] = useState(false)
  useEffect(() => {
    // to set the track id state
    setGenerateTrackId(uuid())
  }, [])
  const successMessage = 'Agent created successfully'
  const [uploadAgent] = useMutation(UPLOAD_AGENTS, {
    onCompleted: (data) => {
      if (data.uploadAgents.includes('got failed while creating, Email has been sent')) {
        toaster(data.uploadAgents, 'warning')
      } else if (data.uploadAgents.includes(successMessage)) {
        toaster(data.uploadAgents, 'success')
      } else if (data.uploadAgents.includes(generatedTrackId)) {
        toaster(successMessage, 'success')
      }
      else {
        toaster(data.uploadAgents, 'error')
        return  // This line was added to handle the case where the uploadAgents response does not match expected values  
      }
      checkUploadStatus(generatedTrackId, refetchList)
      handleHide()
      formik.setValues(initialFormValue)
    },
    onError: (error) => {
      alert(error.message, 'error')
      handleHide()
    },
  })
  const validationSchema = Yup.object().shape({
    agent: Yup.array().of(
      Yup.object().shape({
        agentFirstName: Yup.string().required('First Name is required'),
        agentLastName: Yup.string().required('Last Name is required'),
        agentEmailID: Yup.string().required('Email ID is required'),
      })
    ),
  })
  const formik = useFormik({
    initialValues: initialFormValue,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const agentValue: any = formik.getFieldMeta('agent').value
      handleCreateAgentSubmit(
        agentValue,
        createAgents,
        uploadAgent,
        generatedTrackId,
        salesChannelId
      )
      // refetchList()
    },
  })

  // Sync Call
  const [createAgents] = useMutation(CREATE_AGENTS, {
    onCompleted: async (data) => {
      if (data.createAgents.includes('got failed while creating, Email has been sent')) {
        toaster(data.createAgents, 'warning')
      } else if (data.createAgents.includes(successMessage)) {
        toaster(data.createAgents, 'success')
      } else {
        toaster(data.createAgents, 'error')
      }
      handleHide()
      refetchList()
      formik.setValues(initialFormValue)
    },
    onError: (error) => toaster(error.message, 'error'),
  })
  const handleHide = () => {
    formik.setValues(initialFormValue)
    formik.setTouched({})
    formik.setErrors({})
    handleClose()
  }
  useEffect(() => {
    formik.setFieldValue('agentLeaders', agentLeaderList)
  }, [agentLeaderList])

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName={' modal-dialog-scrollable mw-650px'}
      show={show}
      onHide={handleHide}
      backdrop={true}
    >
      <div className='modal-header'>
        <h4 className='modal-title '>Add Agent</h4>
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleHide}>
          <img className='svg-icon-1' src={closeIcon} alt='close' />
        </div>
      </div>

      <div className='modal-body'>
        <AddAgent formik={formik} setIsSubmit={setIsSubmit} />
      </div>
      <div className='modal-footer'>
        <button
          type='button'
          className='btn btn-light'
          data-bs-dismiss='modal'
          onClick={handleHide}
        >
          Discard
        </button>
        <button
          type='submit'
          className='btn btn-primary'
          disabled={!isSubmit}
          onClick={() => formik.submitForm()}
        >
          Submit
        </button>
      </div>
    </Modal>,
    modalsRoot
  )
}

export { CreateAgentModel }
